var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLogoGoshaper = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 244.02 240.43",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Warstwa_2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Warstwa_2-2",
  "data-name": "Warstwa 2"
}, /*#__PURE__*/React.createElement("polygon", {
  points: "240.13 96.89 197.37 96.89 96.59 96.89 96.59 143.54 197.37 143.54 197.37 240.43 244.02 240.43 244.02 96.89 240.13 96.89"
}), /*#__PURE__*/React.createElement("polygon", {
  points: "244.02 46.65 244.02 0 0 0 0 39.47 0 46.65 0 193.78 0 197.37 0 240.43 147.13 240.43 147.13 193.78 46.65 193.78 46.65 46.65 244.02 46.65"
})))));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogoGoshaper, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo_goshaper.ab1d2193.svg";
export { ForwardRef as ReactComponent };